import script from "./Game.vue?vue&type=script&setup=true&lang=ts"
export * from "./Game.vue?vue&type=script&setup=true&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=eda60da0&scoped=true&lang=css"
import "./Game.vue?vue&type=style&index=1&id=eda60da0&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda60da0"]])

export default __exports__